import { Component, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatStepper } from '@angular/material';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CommonHelper } from '../../../../utilities/common.helper';

@Component({
	selector: 'kt-questionnaire',
	templateUrl: './questionnaire.component.html',
	styleUrls: ['./questionnaire.component.css']
})
export class QuestionnaireComponent implements OnInit {
	isLinear = true;
	@ViewChild('stepper', { static: false }) stepper: MatStepper;
	firstFormGroup: FormGroup;
	secondFormGroup: FormGroup;
	public questionsList: any = [];
	public questionnaireForm: FormGroup;
	public selectionQuestionnairAnswer: any = [];
	public showError: boolean = false;
	public answersList: any = [];
	constructor(private dialogRef: MatDialogRef<QuestionnaireComponent>, private fb: FormBuilder,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,) { }

	ngOnInit() {
		this.firstFormGroup = this.fb.group({
			firstCtrl: ['', Validators.required]
		});
		this.secondFormGroup = this.fb.group({
			secondCtrl: ['', Validators.required]
		});
		this.questionsList = this.data.questions;
		this.createQuestionnaireForm();
		for (let i = 0; i < this.questionsList.length; i++) {
			this.addNewQuestionnaire(this.questionsList[i]);
		}

	}


	private createQuestionnaireForm(): void {
		this.questionnaireForm = this.fb.group({
			questionnaireDtoList: this.fb.array([]),
		})
	}

	public getQuestionnaireList(): any {
		return this.questionnaireForm.controls.questionnaireDtoList['controls'];
	}

	public addNewQuestionnaire(data): void {
		const eduValues = this.questionnaireForm.controls.questionnaireDtoList as FormArray;
		let newRow = this.fb.group({
			isChecked: new FormControl(null, [Validators.required]),
			questionId: new FormControl(data.questionnaireId ? data.questionnaireId : null),

		});
		eduValues.push(newRow);
	}

	public getRadioSelection(event, index) {
		this.selectionQuestionnairAnswer[index] = event.value;

		this.showError = false;
	}

	moveToNextTab(index) {
		if (this.selectionQuestionnairAnswer[index]) {
			{
				if (this.data.processAcronym == 'IRSIP')
					this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 1, irsipApplicationId: this.questionsList[index].irsipApplicationId });
				else if (this.data.processAcronym == 'PSP')
					this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 1, pspApplicationId: this.questionsList[index].pspApplicationId });
				this.stepper.next();
			}
		} else {
			if (!this.questionsList[index].isMandatory) {
				if (this.data.processAcronym == 'IRSIP')
					this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 0, irsipApplicationId: this.questionsList[index].irsipApplicationId });
				else if (this.data.processAcronym == 'PSP')
					this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 0, pspApplicationId: this.questionsList[index].pspApplicationId });
				this.stepper.next();
			}
			else this.showError = true;
		}
	}

	moveToPrvTab() {

		this.stepper.previous();
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public onButtonClose() {
		this.dialogRef.close(false);
	}

	public onButtonSubmit(index) {
		if (this.selectionQuestionnairAnswer[index]) {
			if (this.data.processAcronym == 'IRSIP')
				this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 1, irsipApplicationId: this.questionsList[index].irsipApplicationId });
			else if (this.data.processAcronym == 'PSP')
				this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 1, pspApplicationId: this.questionsList[index].pspApplicationId });
			this.dialogRef.close(this.answersList);
			return;
		} else {
			if (!this.questionsList[index].isMandatory) {
				if (this.data.processAcronym == 'IRSIP')
					this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 0, irsipApplicationId: this.questionsList[index].irsipApplicationId });
				else if (this.data.processAcronym == 'PSP')
					this.answersList.push({ id: this.questionsList[index].id, questionnaireId: this.questionsList[index].questionnaireId, isAnswered: 0, pspApplicationId: this.questionsList[index].pspApplicationId });
				this.dialogRef.close(this.answersList);
				return;
			}
			else this.showError = true;
		}

		if (!this.showError) {
			this.dialogRef.close(this.answersList);
		}
	}


}
